import React from "react";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {connect} from "react-redux";
import {getStepTitel} from '../store/actions/main';
import {setUpdateButtonActiveStepToFalse, setUpdateButtonActiveStepToTrue} from '../store/actions/main';
import {useStyles} from '../style/materialUi';
//steps
//Zaun
import StepZauneOne from '../Main/Products/Zaune/steps/step_1';
import StepZauneTwo from '../Main/Products/Zaune/steps/step_2';
import StepZauneThree from '../Main/Products/Zaune/steps/step_3';
import StepZauneFour from '../Main/Products/Zaune/steps/step_4';
import StepZauneFive from '../Main/Products/Zaune/steps/step_5';
import StepZauneSix from '../Main/Products/Zaune/steps/step_6';

//Tor
import StepToreOne from '../Main/Products/Tore/steps/step_1'
import StepToreTwo from '../Main/Products/Tore/steps/step_2';
import StepToreThree from '../Main/Products/Tore/steps/step_3';
import StepToreFour from '../Main/Products/Tore/steps/step_4';
import StepToreFive from '../Main/Products/Tore/steps/step_5';
import StepToreSix from '../Main/Products/Tore/steps/step_6';
import StepToreSeven from '../Main/Products/Tore/steps/step_7';
import StepToreEight from '../Main/Products/Tore/steps/step_8';

//Pforte
import StepPforteOne from '../Main/Products/Pforten/steps/step_1';
import StepPforteTwo from '../Main/Products/Pforten/steps/step_2';
import StepPforteThree from '../Main/Products/Pforten/steps/step_3';
import StepPforteFour from '../Main/Products/Pforten/steps/step_4';
import StepPforteFive from '../Main/Products/Pforten/steps/step_5';
import StepPforteSix from '../Main/Products/Pforten/steps/step_6';
import StepPforteSeven from '../Main/Products/Pforten/steps/step_7';

//Geländer
import StepGelaenderOne from '../Main/Products/Gelaender/steps/step_1.js';
import StepGelaenderTwo from '../Main/Products/Gelaender/steps/step_2';
import StepGelaenderThree from '../Main/Products/Gelaender/steps/step_3';
import StepGelaenderFour from '../Main/Products/Gelaender/steps/step_4';
import StepGelaenderFive from '../Main/Products/Gelaender/steps/step_5';
import StepGelaenderSix from '../Main/Products/Gelaender/steps/step_6';
import StepGelaenderSeven from '../Main/Products/Gelaender/steps/step_7';
import StepGelaenderGlas from '../Main/Products/Gelaender/steps/step_glas';
import StepGelaenderColor from '../Main/Products/Gelaender/steps/step_color';

//Vordächer
import StepVordaecherOne from '../Main/Products/Vordaecher/steps/step_1';
import StepVordaecherTwo from '../Main/Products/Vordaecher/steps/step_2';
import StepVordaecherThree from '../Main/Products/Vordaecher/steps/step_3';
import StepVordaecherPfosten from '../Main/Products/Vordaecher/steps/step_pfosten';

//Stahltreppen
import StepStahltreppenOne from '../Main/Products/Stahltreppen/steps/step_1';
// import StepStahltreppenTwo from '../Main/Products/Stahltreppen/steps/step_2';
import StepStahltreppenThree from '../Main/Products/Stahltreppen/steps/step_3';
import StepStahltreppenFour from '../Main/Products/Stahltreppen/steps/step_4';
import StepStahltreppenFive from '../Main/Products/Stahltreppen/steps/step_5';
import StepStahltreppenSix from '../Main/Products/Stahltreppen/steps/step_6';
import StepStahltreppenSeven from '../Main/Products/Stahltreppen/steps/step_7';


const StepperContainer = (props) => {

  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});


  const getSteps = () => {
    let element = '';

    switch (props.url) {
      //zäune
      case 'Zaun':
        element = ['Muster', 'Bemaßung', 'Oberfläche', 'Spitzen', 'Pfosten', 'Abschluss'];
      break;
      //tore
      case 'Tore':
        element = ['Muster', 'Bemaßung', 'Oberfläche', 'Spitzen', 'Pfosten', 'Antrieb', 'Öffnungsrichtung', 'Abschluss'];
      break;
      //pforten
      case 'Pforte':
        element = ['Muster', 'Bemaßung', 'Oberfläche', 'Spitzen', 'Pfosten', 'Öffnungsrichtung', 'Abschluss'];
      break;
      //geländer
      case 'Stahlgeländer':
        element = ['Muster', 'Grundriss', 'Bemaßung', 'Handlauf', 'Pfosten', 'Oberfläche', 'Befestigungsart', 'Abschluss'];
      break;
      case 'Edelstahlgeländer':
        element = ['Muster', 'Grundriss', 'Bemaßung', 'Handlauf', 'Pfosten', 'Befestigungsart', 'Abschluss'];
      break;
      case 'Treppenhandlauf Edelstahl':
        element = ['Grundriss', 'Bemaßung', 'Handlauf', 'Pfosten', 'Befestigungsart', 'Abschluss'];
      break;
      case 'Geländer mit Glas':
        element = ['Muster', 'Grundriss', 'Bemaßung', 'Oberfläche', 'Handlauf', 'Pfosten', 'Befestigungsart', 'Glastönung', 'Abschluss'];
      break;
      //vordächer
      case 'Vordächer':
        element = ['Bemaßung', 'Glastönung', 'Abschluss'];
      break;
      case 'Glasvordach mit Pfosten':
        element = ['Bemaßung', 'Glastönung', 'Pfosten', 'Abschluss'];
      break;
      //stahltreppe
      case 'Stahltreppe':
        element = ['Geländer', 'Geschosshöhe', 'Stufenbreite', 'Podest', 'Oberfläche', 'Abschluss']
      break;

      default:
        return props.url;
    }

    return element;
  }

  const steps = getSteps();

  const getStepContent = (step) => {
    let Stepone, Steptwo, Stepthree, Stepfour, Stepfive, Stepsix, Stepseven, Stepeight, Stepnine = undefined;

    switch (props.url) {
      case 'Zaun':
        Stepone = StepZauneOne;
        Steptwo = StepZauneTwo;
        Stepthree = StepZauneThree;
        Stepfour = StepZauneFour;
        Stepfive = StepZauneFive;
        Stepsix = StepZauneSix;
        break;
      case 'Tore':
        Stepone = StepToreOne;
        Steptwo = StepToreTwo;
        Stepthree = StepToreThree;
        Stepfour = StepToreFour;
        Stepfive = StepToreFive;
        Stepsix = StepToreSix;
        Stepseven = StepToreSeven;
        Stepeight = StepToreEight;
        break;
      case 'Pforte':
        Stepone = StepPforteOne;
        Steptwo = StepPforteTwo;
        Stepthree = StepPforteThree;
        Stepfour = StepPforteFour;
        Stepfive = StepPforteFive;
        Stepsix = StepPforteSix;
        Stepseven = StepPforteSeven;
        break;
      case 'Stahlgeländer':
        Stepone = StepGelaenderOne;
        Steptwo = StepGelaenderTwo;
        Stepthree = StepGelaenderThree;
        Stepfour = StepGelaenderFour;
        Stepfive = StepGelaenderFive;
        Stepsix = StepGelaenderColor;
        Stepseven = StepGelaenderSix;
        Stepeight = StepGelaenderSeven;
        break;
      case 'Edelstahlgeländer':
        Stepone = StepGelaenderOne;
        Steptwo = StepGelaenderTwo;
        Stepthree = StepGelaenderThree;
        Stepfour = StepGelaenderFour;
        Stepfive = StepGelaenderFive;
        Stepsix = StepGelaenderSix;
        Stepseven = StepGelaenderSeven;
        break;
      case 'Treppenhandlauf Edelstahl':
        Stepone = StepGelaenderTwo;
        Steptwo = StepGelaenderThree;
        Stepthree = StepGelaenderFour;
        Stepfour = StepGelaenderFive;
        Stepfive = StepGelaenderSix;
        Stepsix = StepGelaenderSeven;
        break;
      case 'Geländer mit Glas':
        Stepone = StepGelaenderOne;
        Steptwo = StepGelaenderTwo;
        Stepthree = StepGelaenderThree;
        Stepfour = StepGelaenderColor;
        Stepfive = StepGelaenderFour;
        Stepsix = StepGelaenderFive;
        Stepseven = StepGelaenderSix;
        Stepeight = StepGelaenderGlas;
        Stepnine = StepGelaenderSeven;
        break;
      case 'Vordächer':
        Stepone = StepVordaecherOne;
        Steptwo = StepVordaecherTwo;
        Stepthree = StepVordaecherThree;
        break;
      case 'Glasvordach mit Pfosten':
        Stepone = StepVordaecherOne;
        Steptwo = StepVordaecherTwo;
        Stepthree = StepVordaecherPfosten;
        Stepfour = StepVordaecherThree;
        break;
      case 'Stahltreppe':
        Stepone = StepStahltreppenOne;
        Steptwo = StepStahltreppenThree;
        Stepthree = StepStahltreppenFour;
        Stepfour = StepStahltreppenFive;
        Stepfive = StepStahltreppenSix;
        Stepsix = StepStahltreppenSeven;
      break;

      default:
        return props.url;
    }

    switch (step) {
      case 0:
        return <Stepone />;
      case 1:
        return <Steptwo />;
      case 2:
        return <Stepthree />;
      case 3:
        return <Stepfour />;
      case 4:
        return <Stepfive />;
      case 5:
        return <Stepsix />;
      case 6:
        return <Stepseven />;
      case 7:
        return <Stepeight />;
      case 8:
        return <Stepnine />;
      default:
        return step;
    }
  }

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };


  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep = isLastStep() && !allStepsCompleted() ?  steps.findIndex((step, i) => !(i in completed)) : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    // props.setUpdateButtonActiveStepToTrue();
  };

  const _handleSteps = (step) => () => {
    let visited_steps = '';
    let findStep = '';

    switch (props.url) {
      case 'Zaun':
        visited_steps = props.visited_steps_zaune.steps[1].active_steps;
      break;
      case 'Tore':
        visited_steps = props.visited_steps_tore;
      break;
      case 'Pforte':
        visited_steps = props.visited_steps_pforte.steps[1].active_steps;
      break;
      case 'Stahlgeländer':
        visited_steps = props.visited_steps_gelaender[0].steps[1].active_steps;
      break;
      case 'Edelstahlgeländer':
        visited_steps = props.visited_steps_gelaender[1].steps[1].active_steps;
      break;
      case 'Geländer mit Glas':
        visited_steps = props.visited_steps_gelaender[2].steps[1].active_steps;
      break;
      case 'Treppenhandlauf Edelstahl':
        visited_steps = props.visited_steps_gelaender[3].steps[1].active_steps;
      break;
      case 'Vordächer':
        visited_steps = props.visited_steps_vordaecher;
      break;
      case 'Glasvordach mit Pfosten':
        visited_steps = props.visited_steps_vordaecher;
      break;
      case 'Stahltreppe':
        visited_steps = props.visited_steps_stahltreppen.steps[1].active_steps;
      break;
      default:
        return props.url;
    }

    findStep = visited_steps.find(elem => elem === step);

    if (findStep !== undefined) {
      setActiveStep(findStep);
    }

  }

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  return (
    <div className='mainStepWrapper'>
      <h2 id="step_header">{steps[activeStep]}</h2>
      <Stepper className={classes.MuiStep_horizontal} nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step className="stepButtons" key={index}>
              <StepButton id="stepbutton" className={classes.stepIcons} onClick={_handleSteps(index)} completed={completed[index]}>
                <span className="stepLabel">{label}</span>
              </StepButton>
          </Step>
        ))}
      </Stepper>
      <div className={classes.main_container}>
        {allStepsCompleted() ? (
          <div>
            <Typography className={classes.instructions}> All steps completed - you&apos;re finished </Typography>
            <Button onClick={handleReset}>Reset</Button>
          </div>
        ) : (
          <div className="content-wrapper">
            {getStepContent(activeStep)}
            <div id="button_wrapper" className="button_wrapper">
              <Button disabled={activeStep === 0} variant="contained" onClick={handleBack} className={classes.button}> Zurück </Button>
              <Button variant="contained" disabled={props.buttonActiveStep} onClick={handleNext} className={classes.button}> Weiter </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = state => {
    return {
      url: state.mainReducer.url,
      buttonActiveStep: state.mainReducer.buttonActiveStep,
      visited_steps_zaune: state.zauneReducer.data,
      visited_steps_tore: state.toreReducer.allVisitedSteps,
      visited_steps_pforte: state.pfortenReducer.data,
      visited_steps_gelaender: state.gelaenderReducer.data,
      visited_steps_vordaecher: state.vordaecherReducer.allVisitedSteps,
      visited_steps_stahltreppen: state.stahltreppenReducer.data
    }
}

const mapStateToDispatch = dispatch => {
    return {
      getStepTitel: ev => dispatch(getStepTitel(ev)),
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue())
    }
}


export default connect(mapStateToProps, mapStateToDispatch)(StepperContainer);
